import { render, staticRenderFns } from "./UserAuth.vue?vue&type=template&id=0c2d252b"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"
import style0 from "./UserAuth.vue?vue&type=style&index=0&id=0c2d252b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports